import { IUser } from "@imaginelearning/mps-api-service";
import {
  UxAvatar,
  UxAvatarEnum,
  UxAvatarPriorityEnum,
  UxAvatarStyleEnum,
  UxSizeExtendedEnum
} from "@imaginelearning/mps-ux-component-library";
import { UserContext } from "context-providers/user.provider";
import React, { useContext } from "react";
import "./no-assignment-page.scss";

function NoAssignmentPage() {
  const { userState } = useContext(UserContext);
  const user: IUser = userState.response as IUser;
  return (
    <div>
      <div className="box1">No assignments here.</div>
      <div className="triangle" />
      <div className="no-assignment">
        <UxAvatar
          avatar={(user.selectedAvatar as UxAvatarEnum) || UxAvatarEnum.DAISY}
          avatarType={UxAvatarPriorityEnum.DEFAULT}
          size={UxSizeExtendedEnum.X5}
          avatarStyle={UxAvatarStyleEnum.BODY}
          className="d-flex no-assign-avatar"
        />
      </div>
    </div>
  );
}
export default NoAssignmentPage;
